import React from "react";
import { InputAdornment } from "@mui/material";
import TextFiledWithLabel from "../../../Components/TextFieldWithLabel";
import "./color-field.css";
// Accept RGB and RRGGBB values
export const isValidColor = (value) =>
  typeof value === "string" &&
  /^#(?:[\da-f]{3}|[\da-f]{6})$/i.test(value.trim());

const getPickerColor = (value, fallback) => {
  if (!isValidColor(value)) return fallback;

  const color = value.trim();

  if (color.length === 4) {
    return `#${color[1]}${color[1]}${color[2]}${color[2]}${color[3]}${color[3]}`;
  }

  return color;
};

const ColorField = ({
  name,
  label,
  value = "",
  handleOnChange,
  fallbackColor = "#000000",
  disabled = false,
  error = false,
  helperText = "",
  className = "",
  fullWidth = false,
  size = "small",
}) => {
  const pickerColor = getPickerColor(value, fallbackColor);

  return (
    <TextFiledWithLabel
      name={name}
      label={label}
      value={value}
      handleOnChange={handleOnChange}
      isViewMode={disabled}
      error={error}
      helperText={helperText}
      fullWidth={fullWidth}
      size={size}
      className={`color-field ${className}`.trim()}
      placeholder="#1242C9"
      inputProps={{
        maxLength: 7,
        spellCheck: false,
        autoComplete: "off",
        "aria-label": `${label} hex code`,
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start" className="color-field-prefix">
            HEX
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end" className="color-field-adornment">
            <label
              className={`color-field-swatch${disabled ? " color-field-swatch-disabled" : ""}`}
              title="Choose color"
              style={{ "--picker-color": pickerColor }}
            >
              <input
                className="color-field-picker"
                type="color"
                name={name}
                value={pickerColor}
                onChange={handleOnChange}
                aria-label={`Choose ${label}`}
                disabled={disabled}
                tabIndex={disabled ? -1 : 0}
              />
            </label>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default ColorField;